import React from "react";
import "./Product.css";
import { useStateValue } from "./StateProvider";
import { Card, Button, Typography, Rate, Space } from "antd";
import { ShoppingCartOutlined, StarFilled } from '@ant-design/icons';

const { Title, Text } = Typography;

function Product({ id, title, image, price, rating }) {
  const [{ basket, user }, dispatch] = useStateValue();
  const reviewCount = React.useMemo(() => Math.floor(Math.random() * 500) + 12, []);

  const addToBasket = () => {
    const newItem = { id, title, image, price, rating };

    dispatch({
      type: "ADD_TO_BASKET",
      item: newItem,
    });

    if (user) {
      const updatedBasket = [...basket, newItem];
      localStorage.setItem(`basket_${user.uid}`, JSON.stringify(updatedBasket));
    }
  };

  return (
    <Card
      hoverable
      className="product-card"
      bordered={true}
      cover={
        <div className="product-card__cover">
          <img
            src={image}
            alt={title}
            className="product-card__image"
          />
        </div>
      }
    >
      <div className="product-card__content">
        <Title level={4} className="product-card__title" ellipsis={{ rows: 2 }}>
          {title}
        </Title>
        <Space direction="vertical" size={2} style={{ width: '100%', flexGrow: 1 }}>
          <Text className="product-card__price">
            <span className="product-card__currency">$</span>{parseInt(price)}
            <span className="product-card__cents">{(price % 1).toFixed(2).substring(1)}</span>
          </Text>
          <div className="product-card__rating">
            <Rate disabled defaultValue={rating} character={<StarFilled />} style={{ color: '#fbbf24', fontSize: '14px' }} />
            <Text type="secondary" style={{ marginLeft: '8px', fontSize: '13px' }}>({reviewCount})</Text>
          </div>
        </Space>

        <Button
          type="primary"
          block
          className="product-card__btn"
          icon={<ShoppingCartOutlined />}
          onClick={addToBasket}
          aria-label={`Add ${title} to basket`}
        >
          Add to Cart
        </Button>
      </div>
    </Card>
  );
}

export default Product;
